import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import { decodeHandler, forbidExtraProps } from "utils";
import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";

function Header(props) {
  const [decodedString, setDecodedString] = useState("");

  useEffect(() => {
    async function decodeString() {
      // Check if props.title contains "Backup Settings" or "Activity Logs"
      if (
        props.name &&
        props.title &&
        (props.title.includes("Backup Settings") ||
          props.title.includes("Activity Logs"))
      ) {
        // Simulating asynchronous decoding operation
        const decoded = decodeHandler(
          props.clients.list[props.clientUUID].name
        );
        setDecodedString(decoded);
      } else {
        // If not, decode props.name
        const decoded = decodeHandler(props.name);
        setDecodedString(decoded);
      }
    }

    decodeString(); // Call the decoding function
  }, [props]);

  return (
    <div className="slider_header">
      <div className="main_title">
        <Tooltip
          {...(props.name ? { title: decodedString, placement: "bottom" } : {})}
        >
          <span className="slider_main_title">
            {props.title
              ? [
                  props.title,
                  props.name
                    ? props.title.includes("Backup Settings") ||
                      props.title.includes("Activity Logs")
                      ? " (" + decodedString + ")"
                      : " (" + decodedString + ")"
                    : ""
                ].join("")
              : decodedString}
          </span>
        </Tooltip>
        {props.toolTip && (
          <Tooltip {...props.toolTip}>
            <span className="icon">
              <InformationIcon />
            </span>
          </Tooltip>
        )}
        {/* {props.currentTab === "restore" && (
          <div
            className="download_iso"
            onClick={() => props.openPopup("downloadRestoreISO", {})}
          >
            System Restore
          </div>
        )} */}
      </div>
      {props.isClose && (
        <Tooltip {...TOOLTIPS.slidingPopup.close}>
          <div
            className="slider_close propSlider_close flex_center"
            onClick={props.closeSlider}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </div>
        </Tooltip>
      )}
    </div>
  );
}

Header.propTypes = forbidExtraProps(
  {
    title: PropTypes.string,
    name: PropTypes.string,
    refresh: PropTypes.shape({
      show: PropTypes.bool
    }),
    notify: PropTypes.shape({
      show: PropTypes.bool,
      params: PropTypes.object
    }),
    currentTab: PropTypes.object,
    clientUUID: PropTypes.string,
    clients: PropTypes.object
  },
  ["closeNotify", "openPopup"]
);

function mapStateToProps(state) {
  return {
    clients: state.dashboard.clients
  };
}

export default connect(mapStateToProps)(Header);
